import HasCollectionPoints from '../../enums/HasCollectionPoints';

export const COLLECTION_INITIAL_NUMBER_POINTS = 8;

export default {
  savedAddresses: [],
  hideCollectionPoint: false,
  isAddCollectionPoint: false,
  isDisplayPostcodeInput: true,
  isDisplayCollectionPointInfo: false,
  isDisplayCollectorName: false,
  indexOfAddressToShowInCollectorName: null,
  isDisplayFilters: false,
  isDisplayListView: !!window.start?.settings?.should_use_new_collection_overlay,
  hasCollectionPoints: HasCollectionPoints.PENDING,
  initialCollectionPoints: [],
  collectionPoints: [],
  collectionPointsToDisplay: [],
  activeCollectionPoint: 0,
  selectedActiveCollectionPoint: 0,
  collectionPointsAmountToDisplay: COLLECTION_INITIAL_NUMBER_POINTS,
  displayCollectionPoint: -1,
  selectedCollectionPoint: -1,
  collectorName: window.start?.settings?.should_use_new_collection_overlay ? (window.start?.customer?.fullName || '') : '',
  mapZoom: 3,
  currentLocation: {
    latlng: null,
    address: '',
    postcode: '',
    locality: '',
    country: window.siteObj.userLocation,
  },
  mapCenter: {lat: 0, lng: 0},
  defaultCenter: {lat: 0, lng: 0},
  initialAddressLength: 0,
  filterValues: [],
  searchDescription: window?.pudo?.searchDescription || '',
};
